<template>
  <div id="landing">
    <SectionTitle showApply />
    <SectionWhy />
    <SectionBenefit />
    <SectionProcess />
    <SectionFee showApply />
    <SectionReview />
    <SectionMoney showApply />
    <SectionFooter />
    <!-- <div class="bottom-button">
      <transition name="fade">
        <BasicButton class="btn-kakao slow" @click="goNext">
          받을 돈 조회하기
          <img class="ml-2" src="@/assets/images/landing/arrow.svg" />
        </BasicButton>
      </transition>
    </div> -->
  </div>
</template>

<script>
import SectionTitle from '@/components/landing/SectionTitle.vue'
import SectionWhy from '@/components/landing/SectionWhy.vue'
import SectionBenefit from '@/components/landing/SectionBenefit.vue'
import SectionProcess from '@/components/landing/SectionProcess.vue'
import SectionFee from '@/components/landing/SectionFee.vue'
import SectionReview from '@/components/landing/SectionReview.vue'
import SectionMoney from '@/components/landing/SectionMoney.vue'
import SectionFooter from '@/components/landing/SectionFooter.vue'

export default {
  components: {
    SectionTitle,
    SectionWhy,
    SectionBenefit,
    SectionProcess,
    SectionFee,
    SectionReview,
    SectionMoney,
    SectionFooter,
  },
  methods: {
    async goNext() {
      this.$router.push({ name: 'signup/agreements/nice' })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common/_variables.scss';

#landing {
  .bottom-button {
    position: fixed;
    display: flex;
    bottom: 30px;
    max-width: 720px;
    width: 80vw;
    // z-index: 1000;
    left: 50%;
    transform: translateX(-50%);

    button.btn-kakao {
      border-radius: 32px;
      box-shadow: 0 8px 14px 0 rgba(0, 0, 0, 0.14);
      &:hover {
        color: white !important;
        background-color: #333333 !important;
      }
    }
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 1s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  :deep(section) {
    padding-top: 40px;
    padding-bottom: 40px;
  }

  :deep(.landing-container) {
    max-width: $standard-max-width;
    margin: 0 auto;
  }
}
</style>
